import React from 'react';
import ReactDOM from 'react-dom/client';

import './index.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Calculate from './Calculate';
import App from './App';
import Caltype from './Caltype';
import Offcalc from './Offcalc';
import Short from './Short';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
     <Router>
        <Routes>
        <Route path="/" element={<Short />} />

          {/* <Route path="/" element={<Caltype />} /> */}
          <Route path="/App" element={<App />} />
          <Route path="/Calculate" element={<Calculate />} />
          <Route path="/Offcalc" element={<Offcalc />} />
          <Route path="/Short" element={<Short />} />
          </Routes>
      </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
